import { COOKING_STEP_TAB_NAME, ITEM_TAB_NAME, PAGE_TAB_NAME_LIST, RECIPE_TAB } from '../constant';
import i18n from '../i18nService';

type I18nInstance = typeof i18n;

type NavigationTab = {
    pageUrl: string;
    title: string;
    isActive: boolean;
};

type TabsObserver = () => void;

const checkActiveRoute = (activeRoute: string, pageUrl: string): boolean => {
    return activeRoute.includes(pageUrl);
};

const createRecipePageTabs = (activeRoute: string, i18nInstance: I18nInstance = i18n): NavigationTab[] => {
    return [
        {
            pageUrl: `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${PAGE_TAB_NAME_LIST}`,
            title: i18nInstance.t('app.page.recipe.recipeTab.item'),
            isActive: checkActiveRoute(activeRoute, `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${PAGE_TAB_NAME_LIST}`),
        },
        {
            pageUrl: `/${RECIPE_TAB}/${COOKING_STEP_TAB_NAME}/${PAGE_TAB_NAME_LIST}`,
            title: i18nInstance.t('app.page.recipe.recipeTab.cookingStep'),
            isActive: checkActiveRoute(activeRoute, `/${RECIPE_TAB}/${COOKING_STEP_TAB_NAME}/${PAGE_TAB_NAME_LIST}`),
        },
    ];
};

export const recipePageNavigationService = {
    observersList: [] as TabsObserver[],
    getTabs(activeRoute: string): NavigationTab[] {
        return createRecipePageTabs(activeRoute);
    },
    getTabName(): string {
        return RECIPE_TAB;
    },
    registerTabsUpdateObserver(observer: TabsObserver): void {
        this.observersList.push(observer);
    },
    unRegisterTabsUpdateObserver(observer: TabsObserver): void {
        this.observersList = this.observersList.filter((observerFunction) => observerFunction !== observer);
    },
    notifyObservers(): void {
        this.observersList.forEach((observer) => observer());
    },
};
